import React, { useEffect, useState, useRef } from "react";
import { LabelHLPure, InputHLPure, ButtonHLPure, TooltipHLPure } from "../../pures";
import { Container, Grid } from '@material-ui/core'
import { Avatar } from "@progress/kendo-react-layout";
import SvgIcon from "@material-ui/core/SvgIcon";
import "./profile-administration-password.css";

const ProfileAdministrationPasswordView = (props) => {
    let {
        t,
        userPathImage,
        handleImage,
        onSubmitChangeUserPassword,
        onHandleGeneralChange,
        changePasswordShowPasswordIcon,
        changePasswordShowPasswordConfirmIcon,
        actualPasswordShowPasswordIcon,
        onHandleShowActualPassword,
        onHandleShowPassword,
        onHandleShowPasswordConfirm,
        handleShowPrincipalView,
        errorForm,
        errorMessage,
        onHandleHideError
    } = props

    const lastInputRef = useRef(null);

    const focusNext = (event) => {
        if (event.key === "Enter") {
            lastInputRef.current.focus();
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            onSubmitChangeUserPassword(t);
        }
    };

    return (
        <Container>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="profileAdministrationPrincipalView-container"
            >
                <div className="profileAdministrationPrincipalView-body">
                    <LabelHLPure
                        text={t("profileAdministrationPasswordView.label")}
                        fontSize={'14px'}
                    />
                    <div className="profileAdministrationPrincipalView-grid-data">
                        <div className="profileAdministrationPrincipalView-container-image">
                            <Avatar
                                shape="circle"
                                type="image"
                                className="profile-container-img"
                            >
                                <img
                                    src={userPathImage}
                                    alt="user image"
                                    className="k-avatar-image profile-img imageSizesStyles"
                                />
                            </Avatar>
                            <div className="profileAdministrationPrincipalView-container-btn">
                                <div className="custom-input-file-p profileAdministrationPrincipalView-btn-image"
                                    xs={8}
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    es={8}
                                >
                                    <input
                                        className="input-file-p"
                                        type="file"
                                        accept="image/*"
                                        id="file"
                                        onClick={(e) => (e.target.value = null)}
                                        onChange={(e) => handleImage(e)}
                                    />
                                    {t("dialogUpdateUserAddress.tooltipButtonImageEdit")}
                                </div>
                            </div>
                        </div>
                        <div className="profileAdministrationPasswordView-container-data">
                            <div className="profileAdministrationPasswordView-container-inputs">
                                {/* Input actual contraseña */}
                                <div>
                                    <LabelHLPure
                                        text={t("profileAdministrationPasswordView.actual.password")}
                                        fontSize={'14px'}
                                    />
                                    <div className="change-password-input-container">
                                        <div className="change-password-input-wrapper">
                                            <i className="fas fa-lock change-password-input-icon" />
                                        </div>
                                        <input
                                            placeholder={t("profileAdministrationPasswordView.actual.password")}
                                            type="password"
                                            className="change-password-input"
                                            id="actualPassword"
                                            onChange={(e) => onHandleGeneralChange(e)}
                                            onKeyDown={focusNext}
                                        />
                                        <div
                                            className={`changePasswordView-show-password-icon ${actualPasswordShowPasswordIcon}`}
                                            onClick={onHandleShowActualPassword}
                                        >
                                            {/* <i className="fas fa-eye" /> */}
                                            <SvgIcon
                                                className={`changePasswordView-password-icon ${actualPasswordShowPasswordIcon}`}
                                            >
                                                <path d="M0 0h24v24H0V0z" fill="none" />
                                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                                            </SvgIcon>
                                        </div>
                                    </div>
                                </div>

                                {/* Input nueva contraseña */}
                                <div>
                                    <LabelHLPure
                                        text={t("changePasswordView.newPassword")}
                                        fontSize={'14px'}
                                        showTooltip={true}
                                        titleTooltip={t("changePasswordView.tooltipTitleRecomendations")}
                                        descriptionTooltip={t("changePasswordView.tooltip.recomendations")}
                                        positionTooltip={"right"}
                                        informationIcon
                                    />
                                    <div className="change-password-input-container">
                                        <div className="change-password-input-wrapper">
                                            <i className="fas fa-lock change-password-input-icon" />
                                        </div>
                                        <input
                                            placeholder={t("changePasswordView.placeholderPassword")}
                                            type="password"
                                            className="change-password-input"
                                            id="password"
                                            onChange={(e) => onHandleGeneralChange(e)}
                                            onKeyDown={focusNext}
                                        />
                                        <div
                                            className={`changePasswordView-show-password-icon ${changePasswordShowPasswordIcon}`}
                                            onClick={onHandleShowPassword}
                                        >
                                            {/* <i className="fas fa-eye" /> */}
                                            <SvgIcon
                                                className={`changePasswordView-password-icon ${changePasswordShowPasswordIcon}`}
                                            >
                                                <path d="M0 0h24v24H0V0z" fill="none" />
                                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                                            </SvgIcon>
                                        </div>
                                    </div>
                                </div>

                                {/* Input repetir contraseña */}
                                <div>
                                    <LabelHLPure
                                        text={t("changePasswordView.confirmNewPassword")}
                                        fontSize={'14px'}
                                        showTooltip={true}
                                    />
                                    <div className="change-password-input-container">
                                        <div className="change-password-input-wrapper">
                                            <i className="fas fa-lock change-password-input-icon" />
                                        </div>
                                        <input
                                            ref={lastInputRef}
                                            placeholder={t(
                                                "changePasswordView.placeholderConfirmPassword"
                                            )}
                                            type="password"
                                            className="change-password-input"
                                            id="confirmPassword"
                                            onChange={(e) => onHandleGeneralChange(e)}
                                            onKeyDown={handleKeyDown}
                                        />
                                        <div
                                            className={`changePasswordView-show-password-icon ${changePasswordShowPasswordConfirmIcon}`}
                                            onClick={onHandleShowPasswordConfirm}
                                        >
                                            {/* <i className="fas fa-eye" /> */}
                                            <SvgIcon
                                                className={`changePasswordView-password-icon ${changePasswordShowPasswordConfirmIcon}`}
                                            >
                                                <path d="M0 0h24v24H0V0z" fill="none" />
                                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                                            </SvgIcon>
                                        </div>
                                    </div>
                                </div>
                                {/* Mensajes de error */}
                                {errorForm === true ? (
                                    <Grid item xs={12}>
                                        <div className="change-password-container-error-label">
                                            <p className="change-password-error-label">
                                                <span>{errorMessage}</span>
                                                <div
                                                    className="change-password-error-label-icon-close"
                                                    onClick={onHandleHideError}
                                                >
                                                    <i className="fas fa-times" />
                                                </div>
                                            </p>
                                        </div>
                                    </Grid>
                                ) : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className="profileAdministrationPasswordView-container-btns">
                        <div className="profileAdministrationPrincipalView-arrow-btns">
                            <ButtonHLPure
                                nameBtn={t("button.cancel")}
                                primary={false}
                                onClickBtn={() => handleShowPrincipalView()}
                            />
                        </div>
                        <ButtonHLPure
                            nameBtn={t("changePasswordView.buttonChangePassword")}
                            primary={true}
                            onClickBtn={() => onSubmitChangeUserPassword(t)}
                        />
                    </div>
                </div>
            </Grid>
        </Container>
    )
}

export { ProfileAdministrationPasswordView as default }